<template>
  <div>
    <keep-alive>
      <PageHeader />
    </keep-alive>
    <router-view
      :style="{ minHeight: this.minHeight, boxSizing: 'border-box' }"
      :minHeight="minHeight"
    />
    <PageFooter />
    <cookie-banner />
  </div>
</template>

<script>
  import PageHeader from '../PageHeader';
  import PageFooter from '../PageFooter';
  import CookieBanner from '@/components/BaseUi/CookieBanner';

  export default {
    data() {
      return {
        minHeight: '0px',
      };
    },

    mounted() {
      this.minHeight = `${
        document.documentElement.clientHeight -
        document.getElementById('page-header').offsetHeight -
        document.getElementById('page-footer').offsetHeight
      }px`;
      // window.onresize = () => {
      //   this.minHeight = `${
      //     document.documentElement.clientHeight -
      //     document.getElementById('page-header').offsetHeight -
      //     document.getElementById('page-footer').offsetHeight
      //   }px`;
      // };
      window.addEventListener('resize', () => {
        this.minHeight = `${
          document.documentElement.clientHeight -
          document.getElementById('page-header').offsetHeight -
          document.getElementById('page-footer').offsetHeight
        }px`;
      });
    },

    components: {
      CookieBanner,
      PageHeader,
      PageFooter,
    },
  };
</script>

<style></style>
